import { createStore, compose } from 'redux'
import rootReducers from './Reducers'
// import createHistory from 'history/createHashHistory'
import { createHashHistory } from 'history';

export const history = createHashHistory()
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store = createStore(
  rootReducers(history),
  composeEnhancers()
)

export default store
